import _str from "shared/util/_str";

// Export each constant individually with "export NAME = value;"
export const ERRORS = {
	NO_ALBUMS: "NO_ALBUMS",
	NO_PHOTOS: "NO_PHOTOS",
};

export const DRAGGABLES = {
	PHOTO: "photo",
};

export const MIN_PHOTO_SIZE = 400;

export const RETURNING_ANIMATION_TIME = 150;
export const SORTING_ANIMATION_TIME = 200;

// this should be the same as $scale-preview in photo organizer's variables.scss
export const PREVIEW_SCALE = 0.7;

export const LAYOUTS = {
	HERO: "hero",
	TWOBYTHREE: "twobythree",
	THREEBYTWO: "threebytwo",
};

export const TOTAL_PHOTO_COUNTS = {
	[LAYOUTS.HERO]: 9,
	[LAYOUTS.TWOBYTHREE]: 6,
	[LAYOUTS.THREEBYTWO]: 6,
};

export const UPLOAD_STYLE = {
	single: "single",
	multiple: "multiple",
};

export const ERROR_CLEAR_TIME = 7000;

export const SORT_BY = {
	date: "date",
	likes: "likes",
};

export const FEEDBACK_STATES = {
	none: "none",
	error: "error",
	adding: "adding",
	deleting: "deleting",
	reordering: "reordering",
};

export const FEEDBACK_TEXT = {
	start: [
		_str("Add some great photos"),
	],

	[FEEDBACK_STATES.adding]: [
		_str("Nice way to start."),
		_str("Hubba hubba."),
		_str("That’s a good one."),
		_str("Yes yes yes yes yes."),
		_str("Killin’ it."),
		_str("Love it."),
		_str("Look at you, hot stuff."),
		_str("They’re going to love you."),
	],

	[FEEDBACK_STATES.deleting]: [
		_str("Peace out, photo."),
		_str("Au revoir!"),
		_str("Bye bye!"),
		_str("Some don’t make the cut."),
		_str("People love these—add more"),
		_str("There’s gotta be more!"),
	],

	tooLow: [
		_str("Only one? Get a few more."),
		_str("Fill this grid out!"),
		_str("More photos, better matches."),
	],
};



// WEBPACK FOOTER //
// ./src/apps/photo_organizer/util/constants.js